const CurrentData = [
    {
        dataheading: "CURRENT WORKING CAPITAL",
        circledataup:"Total",
        circledatadn:"₹1L",
        firstpara:"Working Capital",
        secondpara:"generate 10,000 more than last month working capital",
        color:'#394A7E'
    },
    {
        dataheading: "CURRENT RATIO",
        circledataup:"",
        circledatadn:"1.90",
        firstpara:"Current Ratio",
        secondpara:"0.5 more than last month",
        color:'#9AABDD'
    }
]

export  default CurrentData 
